/**
 * Copy da vitrine do Inbox. Dados puros: texto, caminhos de imagem e chaves de ícone (resolvidas em `icons.jsx`).
 * Regra do texto: frases curtas, palavras do cliente, nenhuma afirmação que o produto não cumpra. O e-mail é um canal novo,
 * ainda não liberado, e fica à vista com a marca "Em breve" (`soon`); tire a marca quando ele for liberado.
 */
const ASSETS = '/assets';

export default {
    title: 'Inbox',
    art: 'o Inbox',
    heroTitle: ['WhatsApp, Instagram, e-mail e chamadas de vídeo.', 'Numa tela só.'],
    summary:
        'Hoje cada conversa mora num aplicativo diferente. No Inbox, a equipe inteira vê e responde tudo num lugar só, e cada chamada do Otto fica na conversa do cliente.',
    stripLabel: 'Tudo chega aqui',
    strip: [
        { name: 'WhatsApp', logo: `${ASSETS}/whatsapp_icon.svg` },
        { name: 'Instagram', logo: `${ASSETS}/Instagram_logo.svg` },
        { name: 'E-mail', logo: `${ASSETS}/gmail_icon.svg`, soon: true },
        { name: 'Processo Já', logo: `${ASSETS}/processo-ja.svg` },
        { name: 'Otto', logo: '/brand/otto/otto-icone.png' },
    ],
    painTitle: 'Uma mensagem chega e a pessoa certa está de folga.',
    before: 'A Marina manda uma mensagem para o WhatsApp do Carlos. Ele não está hoje, e ninguém mais vê o recado. A Marina espera.',
    after: 'A mensagem cai numa lista que a equipe inteira vê. A próxima pessoa disponível responde, e a Marina não espera.',
    demoTitle: 'Veja a tela de atendimento por dentro.',
    demoSub: 'Troque de conversa, mande uma resposta, escreva uma nota interna e abra as mensagens diretas da equipe.',
    glossary: [
        { term: 'Inbox', def: 'A caixa de entrada onde chegam todas as conversas com clientes.', icon: 'inbox' },
        { term: 'Nota interna', def: 'Um recado para a equipe dentro da conversa. O cliente não vê.', icon: 'note' },
        { term: 'Mensagens diretas', def: 'Conversa só entre as pessoas da equipe.', icon: 'dm' },
        { term: 'Chamada do Otto', def: 'A videochamada que fica registrada na conversa.', logo: '/brand/otto/otto-icone.png' },
    ],
    videoTitle: 'O sistema de verdade, por dentro.',
    poster: `${ASSETS}/showcase/inbox-simples.webp`,
    chapters: ['A conversa chega', 'A equipe responde', 'A chamada entra no histórico'],
    exTitle: 'Abra a tela e veja cada peça.',
    exSub: 'Esta é a tela real do Inbox. Escolha uma função e a peça sai da tela.',
    groups: [
        { title: 'Atender', items: ['Todos os canais na mesma lista', 'Respostas e notas internas', 'Mensagens diretas entre a equipe', 'Ligações dentro do Inbox'] },
        { title: 'Organizar', items: ['Atribuição automática', 'Transferência entre agentes', 'Grupos de atendimento', 'Prazo de resposta (SLA)'] },
        { title: 'Acompanhar', items: ['Modo espião para supervisores', 'Nota do cliente (CSAT)', 'Indicaria a empresa? (NPS)', 'Chamadas do Otto na conversa'] },
    ],
    steps: [
        { title: 'Experimente', body: 'Libere o Inbox e veja a tela com a sua equipe.' },
        { title: 'Conecte o canal', body: 'Conecte o WhatsApp ou o Instagram da empresa.' },
        { title: 'Atenda', body: 'As conversas chegam na lista, e as chamadas do Otto entram no histórico.' },
    ],
    extraFaq: {
        q: 'Preciso ter algum canal conectado para começar?',
        a: 'Não para conhecer. A demonstração desta página usa clientes de exemplo. Para atender de verdade, você conecta o WhatsApp ou o Instagram da empresa no segundo passo.',
    },
    finalTitle: 'Coloque o atendimento no mesmo lugar das suas chamadas.',
    finalBullets: [
        'Todos os canais e as chamadas do Otto na mesma conversa',
        'Atribuição automática, transferência entre agentes e modo espião',
        'Notas internas e mensagens diretas para a equipe',
    ],
};
